import { render, staticRenderFns } from "./PlainMessageComponent.vue?vue&type=template&id=edb6e49a&scoped=true"
import script from "./PlainMessageComponent.vue?vue&type=script&lang=ts"
export * from "./PlainMessageComponent.vue?vue&type=script&lang=ts"
import style0 from "./PlainMessageComponent.vue?vue&type=style&index=0&id=edb6e49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6e49a",
  null
  
)

export default component.exports